jQuery(function ($) { // この中であればWordpressでも「$」が使用可能になる

  //ヘッダー現在地
  function targetCu() {
    var margin = 70, //ウインドウ上部からどれぐらいの位置で変化させるか
      sectionTop = new Array, //sectionのTop位置格納用
      current = -1; //現在のカレント位置
    //(1)各targetの縦位置を取得
    $('.position-now').each(function (i) {
      sectionTop[i] = $(this).offset().top;
    });
    //init
    changeNavCurrent(-1);
    //スクロールした時の処理
    $(window).scroll(function () {
      scrollY = $(window).scrollTop();
      //(2)各targetの位置とスクロール位置を比較して、条件にあったらchangeNavCurrentを実行
      for (var i = sectionTop.length - 1; i >= 0; i--) {
        if (scrollY > sectionTop[i] - margin) {
          changeNavCurrent(i);
          break;
        } else {
          $('.header__nav-item').removeClass('is-current');
        }
      };
    });
    //(3)ナビの処理
    function changeNavCurrent(curNum) {
      if (curNum != current) {
        var current = curNum;
        var curNum2 = curNum + 1; //HTML順序用
        $('.header__nav-item').removeClass('is-current');
        $('.header__nav-item:nth-child(' + curNum2 + ')').addClass('is-current');
      }
    };
  }
  //ファンクション実行
  $(window).on('load', function () {
    targetCu();
  });
  var timer = false;
  //リサイズ時ファンクション再実行
  $(window).resize(function () {
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      targetCu();
    }, 200);
  });

  /* ハンバーガーメニュー開閉制御 */
  $(".js-hamburger").on('click', function () {
    $(this).toggleClass('is_active');
    $(".js-drawer").toggleClass('is_active');
    $('.header').toggleClass('is-open');
  });

  $(".js-drawer a").click(function () {
    $(".js-hamburger").removeClass('is_active');
    $(".js-drawer").removeClass('is_active');

  });

  // ボタンの表示設定
  var topBtn = $('.pagetop');
  topBtn.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 400) {
      // 指定px以上のスクロールでボタンを表示
      topBtn.fadeIn();
    } else {
      // 画面が指定pxより上ならボタンを非表示
      topBtn.fadeOut();
    }
  });

  // ボタンをクリックしたらスクロールして上に戻る
  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 300, 'swing');
    return false;
  });

  //ドロワーメニュー
  $("#MenuButton").click(function () {
    // $(".l-drawer-menu").toggleClass("is-show");
    // $(".p-drawer-menu").toggleClass("is-show");
    $(".js-drawer-open").toggleClass("open");
    $(".drawer-menu").toggleClass("open");
    $("html").toggleClass("is-fixed");

  });

  // スムーススクロール (絶対パスのリンク先が現在のページであった場合でも作動)
  $(document).on('click', 'a[href*="#"]', function () {
    let time = 400;
    let header = $('header').innerHeight();
    let target = $(this.hash);
    if (!target.length) return;
    let targetY = target.offset().top - header;
    $('html,body').animate({
      scrollTop: targetY
    }, time, 'swing');
    return false;
  });

  //よくある質問
  $('.faq-head').on('click', function () {
    $(this).next('.faq-inner').slideToggle();
    $(this).toggleClass("is-open");
  });

  //まとめて問い合わせチェック制御
  $(document).on('change', 'input[name="inquiry-id"]', function () {
    var checkedNum = $('input[name="inquiry-id"]:checked').length;
    if (checkedNum == 0) {
      $('.plan-bottom').removeClass('is-shown');
      $('input[name="inquiry-id"]').prop('disabled', false);
      $('.inquiry-id-wrap').css('z-index', '0');
    } else if (checkedNum == 3) {
      $('.plan-bottom').addClass('is-shown');
      $('input[name="inquiry-id"]:not(:checked)').prop('disabled', true);
      $('input[name="inquiry-id"]:not(:checked)').prev($('.inquiry-id-wrap')).css('z-index', '999');
    } else if (checkedNum != 0) {
      $('.plan-bottom').addClass('is-shown');
      $('input[name="inquiry-id"]').prop('disabled', false);
      $('.inquiry-id-wrap').css('z-index', '0');
    }
    $('.plan-bottom__num .num').text(checkedNum);
    
    //まとめて問い合わせフォームパラメータ
    var vals = [];
    $('input[name="inquiry-id"]:checked').each(function () {
      vals.push($(this).val());
    });
    $(".plan-bottom__btn").attr("href", "");
    console.log(vals.length);
    console.log(vals);
    if (vals.length == 1) {
      var url = $('.plan-bottom__btn').attr('href') + '/contact?c-id1=' + vals[0];
    } else if (vals.length == 2) {
      var url = $('.plan-bottom__btn').attr('href') + '/contact?c-id1=' + vals[0] + '&c-id2=' + vals[1];
    } else if (vals.length == 3) {
      var url = $('.plan-bottom__btn').attr('href') + '/contact?c-id1=' + vals[0] + '&c-id2=' + vals[1] + '&c-id3=' + vals[2];
    }
    $(".plan-bottom__btn").attr("href", url);
  });

  //ブラウザバック用
  window.addEventListener('pageshow', function () {
    console.log('pageshow');
    var checkedNum = $('input[name="inquiry-id"]:checked').length;
    if (checkedNum == 0) {
      $('.plan-bottom').removeClass('is-shown');
      $('input[name="inquiry-id"]').prop('disabled', false);
      $('.inquiry-id-wrap').css('z-index', '0');
    } else if (checkedNum == 3) {
      $('.plan-bottom').addClass('is-shown');
      $('input[name="inquiry-id"]:not(:checked)').prop('disabled', true);
      $('input[name="inquiry-id"]:not(:checked)').prev($('.inquiry-id-wrap')).css('z-index', '999');
    } else if (checkedNum != 0) {
      $('.plan-bottom').addClass('is-shown');
      $('input[name="inquiry-id"]').prop('disabled', false);
      $('.inquiry-id-wrap').css('z-index', '0');
    }
    $('.plan-bottom__num .num').text(checkedNum);

    //まとめて問い合わせフォームパラメータ
    var vals = [];
    $('input[name="inquiry-id"]:checked').each(function () {
      vals.push($(this).val());
    });
    $(".plan-bottom__btn").attr("href", "");
    console.log(vals.length);
    console.log(vals);
    if (vals.length == 1) {
      var url = $('.plan-bottom__btn').attr('href') + '/contact?c-id1=' + vals[0];
    } else if (vals.length == 2) {
      var url = $('.plan-bottom__btn').attr('href') + '/contact?c-id1=' + vals[0] + '&c-id2=' + vals[1];
    } else if (vals.length == 3) {
      var url = $('.plan-bottom__btn').attr('href') + '/contact?c-id1=' + vals[0] + '&c-id2=' + vals[1] + '&c-id3=' + vals[2];
    }
    $(".plan-bottom__btn").attr("href", url);
  });

  //まとめて問い合わせ3件以上のときモーダル
  $(document).on('click', '.inquiry-id-wrap', function () {
    console.log('click');
    if ($(this).next('input').prop("disabled")) {
      $('#modalArea').fadeIn();
      console.log('disabled');
    };
  });

  $('#closeModal , #modalBg').click(function () {
    $('#modalArea').fadeOut();
  });

  //何件中何件
  var nextNum = 0;
  var numResult = 1;
  var denoResult = 9;

  window.almOnChange = function (alm) {
    nextNum += 1;
    numResult += 9;
    denoResult += 9;
    console.log("Ajax Load More is loading...");
    // console.log(nextNum);
    console.log($('.plan__table').length);

    $('.alm-reveal:nth-of-type(' + nextNum + ')').after('<span class="plan-num"><div class="plan-num__inner"><span class="numerator">' + numResult + '</span>-<span class="denominator">' + denoResult + '</span>件目</div></span>');
  };

});